import { ArrowLeftIcon } from '@heroicons/react/outline';
import { useQuery } from '@showroomjs/bundles/query';
import { SearchDialog, styled } from '@showroomjs/ui';
import * as React from 'react';
import { Link, useLocation, useNavigate } from '../lib/routing';
import { loadCodeAtPath } from '../route-mapping';
import { colorTheme, THEME } from '../theme';
import { GenericLink } from './generic-link';
const navbarOptions = THEME.navbar;
export const Header = React.forwardRef(function Header(props, forwardedRef) {
    const location = useLocation();
    const { navigate } = useNavigate();
    const [searchValue, setSearchValue] = React.useState('');
    const { data: options, isLoading } = useQuery(['search', searchValue], () => {
        if (!searchValue) {
            return [];
        }
        return import('../lib/get-search-result').then((m) => m.getSearchResult(searchValue));
    });
    return (React.createElement(HeaderRoot, { ref: forwardedRef },
        React.createElement(HeaderInner, null,
            React.createElement(TitleWrapper, null,
                props.backUrl && (React.createElement(HeaderLink, { href: props.backUrl },
                    React.createElement(ArrowLeftIcon, { "aria-label": "Back", width: 20, height: 20 }))),
                navbarOptions.logo && React.createElement(Logo, Object.assign({}, navbarOptions.logo)),
                React.createElement(Title, { to: "/" },
                    THEME.title,
                    ' ',
                    navbarOptions.version && (React.createElement(Version, null,
                        "v",
                        navbarOptions.version)))),
            React.createElement(ItemWrapper, null,
                navbarOptions.items &&
                    navbarOptions.items.map((item, i) => (React.createElement(HeaderLink, { href: item.to, key: i }, item.label))),
                React.createElement(SearchDialog.Root, null,
                    React.createElement(SearchDialog.Trigger, { autoFocus: !!(location.state &&
                            location.state
                                .searchNavigated) },
                        React.createElement(SearchText, null, "Search")),
                    React.createElement(SearchDialog, { options: options || [], placeholder: "Search docs", onSelect: (result) => {
                            if (result) {
                                navigate(result, {
                                    state: {
                                        searchNavigated: true,
                                    },
                                });
                            }
                        }, onHighlightedItemChange: (item) => loadCodeAtPath(`/${item}`), onInputChange: setSearchValue, className: colorTheme, isLoading: isLoading }))))));
});
const Logo = styled('img', {
    maxHeight: '40px',
    width: 'auto',
});
const TitleWrapper = styled('div', {
    display: 'flex',
    gap: '$2',
    alignItems: 'center',
});
const SearchText = styled('span', {
    srOnly: true,
    '@md': {
        srOnly: false,
    },
});
const Version = styled('small', {
    fontSize: '$sm',
    lineHeight: '$sm',
});
const ItemWrapper = styled('div', {
    display: 'flex',
    gap: '$4',
    alignItems: 'center',
});
const HeaderRoot = styled('header', {
    position: 'sticky',
    top: 0,
    backgroundColor: '$primary-800',
    color: 'White',
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
    zIndex: 20,
});
const HeaderInner = styled('div', {
    px: '$4',
    py: '$2',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@md': {
        py: '$3',
    },
});
const HeaderLink = styled(GenericLink, {
    px: '$2',
    '&:focus': {
        outlineColor: '$primary-200',
    },
    display: 'none',
    '@md': {
        display: 'block',
    },
});
const Title = styled(Link, {
    color: 'inherit',
    textDecoration: 'none',
    px: '$2',
    '&:focus': {
        outlineColor: '$primary-200',
    },
    '@md': {
        fontSize: '$xl',
    },
});
//# sourceMappingURL=header.js.map